<template>
  <div class="rhlistDrawer">
    <Modal
      class="common-drawer newModal"
      v-model="showInDrawer"
      title="配置网关"
      width="1300px"
      :mask-closable="false"
      class-name="vertical-center-modal"
    >
      <div slot="header">
        <a class="ivu-modal-close" @click="cccloseDrawer">
          <i class="ivu-icon ivu-icon-ios-close"> </i>
        </a>
        <div class="">
          <div class="ivu-modal-header-inner">配置网关</div>
        </div>
      </div>
      <!--  -->

      <template v-if="!isloading">
        <div class="u-m-t-22" style="height: 21px">
          <div class="gat-labe">
            通信方式：{{ formData.driverName || "-"
            }}<span class="pot" @click="updatereport"
              >变更<span style="color: #555555"
                >(变更通信方式将清空现有网关配置，请谨慎操作)</span
              >
            </span>
          </div>
        </div>
        <div
          class="u-flex u-row-between"
          style="margin-top: 16px; margin-bottom: 8px"
        >
          <div class="u-flex">
            <Button
              type="primary"
              @click="association()"
              :loading="btnLoading"
              style="margin-right: 10px"
              >{{ runisfinis ? "重新关联润滑点" : "关联润滑点" }}</Button
            >
            <Button
              type="primary"
              @click="gatedistri()"
              :loading="btnLoading"
              :disabled="apointShow"
            >
              {{ finishCode == 1 ? "点表已下发" : "下发点表" }}
              <!-- {{ finishCode==1?"下发点表":(apointShow||list.length==0) ? "点表已下发" : "下发点表" }} -->
            </Button>
            <!--  -->
          </div>

          <Button v-if="list.length > 0" @click="navtoproedit()"
            >配置点表</Button
          >
        </div>

        <template v-if="this.poinitType == 'RTU'">
          <div class="lua-table">
            <div class="lua-table-th">
              <div class="lua-table-th-lable" style="width: 4%">序号</div>
              <div class="lua-table-th-lable" style="width: 13%">
                润滑点名称
              </div>
              <div class="lua-table-th-lable" style="width: 12%">
                润滑点编号
              </div>
              <div class="lua-table-th-lable" style="width: 9%">监测装置</div>
              <div class="lua-table-th-lable" style="width: 7%">设备</div>
              <div class="lua-table-th-lable" style="width: 9%">客户</div>
              <div class="lua-table-th-lable" style="width: 7%">串口设备</div>
              <div class="lua-table-th-lable" style="width: 7%">波特率</div>
              <div class="lua-table-th-lable" style="width: 8%">数据位</div>
              <div class="lua-table-th-lable" style="width: 6%">停止位</div>
              <div class="lua-table-th-lable" style="width: 8%">
                起偶位校检位
              </div>
              <div class="lua-table-th-lable" style="width: 5%">轮询周期</div>
              <div class="lua-table-th-lable" style="width: 8%">操作</div>
            </div>
            <div class="lua-table-td">
              <template v-if="list.length > 0">
                <div class="td-item" v-for="(indx, key) in list" :key="key">
                  <div class="lua-table-td-lable u-flex" style="width: 4%">
                    <div style="width: 100%" class="line-2">{{ key + 1 }}</div>
                  </div>
                  <div class="lua-table-td-lable" style="width: 13%">
                    <div style="width: 100%" class="line-2">
                      {{ indx.oilSiteName || "-" }}
                    </div>
                  </div>
                  <div class="lua-table-td-lable" style="width: 12%">
                    <div style="width: 100%" class="line-2">
                      {{ indx.oilSiteIotName || "-" }}
                    </div>
                  </div>
                  <div class="lua-table-td-lable" style="width: 9%">
                    <div style="width: 100%" class="line-2">
                      {{ indx.zhuangzhiName || "-" }}
                    </div>
                  </div>
                  <div class="lua-table-td-lable" style="width: 7%">
                    <div style="width: 100%" class="line-2">
                      {{ indx.deviceName || "-" }}
                    </div>
                  </div>
                  <div class="lua-table-td-lable" style="width: 9%">
                    <div style="width: 100%" class="line-2">
                      {{ indx.customerName || "-" }}
                    </div>
                  </div>
                  <div class="lua-table-td-lable" style="width: 7%">
                    <div style="width: 100%" class="line-2">
                      {{ indx.portName || "-" }}
                    </div>
                  </div>
                  <div class="lua-table-td-lable" style="width: 7%">
                    <div style="width: 100%" class="line-2">
                      {{ indx.parameter1 || "-" }}
                    </div>
                  </div>
                  <div class="lua-table-td-lable" style="width: 8%">
                    <div style="width: 100%" class="line-2">
                      {{ indx.parameter2 || "-" }}
                    </div>
                  </div>
                  <div class="lua-table-td-lable" style="width: 6%">
                    <div style="width: 100%" class="line-2">
                      {{ indx.parameter4 || "-" }}
                    </div>
                  </div>
                  <div class="lua-table-td-lable" style="width: 8%">
                    <div style="width: 100%" class="line-2">
                      {{ indx.parameter3 || "-" }}
                    </div>
                  </div>
                  <div class="lua-table-td-lable" style="width: 5%">
                    <div style="width: 100%" class="line-2">
                      {{ indx.interval || "-" }}
                    </div>
                  </div>
                  <div class="lua-table-td-lable" style="width: 8%">
                    <div style="width: 100%" class="line-2 blue-btn u-flex">
                      <div
                        class="pot"
                        style="margin-right: 7px"
                        @click="deploy(indx)"
                      >
                        配置物联
                      </div>
                      <!-- <div
                        class="pot"
                        style="margin-right: 7px"
                        @click="del(indx)"
                      >
                        删除
                      </div> -->
                    </div>
                  </div>
                </div>
              </template>
              <div v-else class="u-flex u-row-center u-col-center mh">
                暂无内容
              </div>
            </div>
          </div>
        </template>
        <template v-else>
          <div class="lua-table">
            <div class="lua-table-th">
              <div class="lua-table-th-lable" style="width: 4%">序号</div>
              <div class="lua-table-th-lable" style="width: 15%">
                润滑点名称
              </div>
              <div class="lua-table-th-lable" style="width: 13%">
                润滑点编号
              </div>
              <div class="lua-table-th-lable" style="width: 8%">监测装置</div>
              <div class="lua-table-th-lable" style="width: 10%">设备</div>
              <div class="lua-table-th-lable" style="width: 8%">客户</div>
              <div class="lua-table-th-lable" style="width: 9%">IP地址</div>
              <div class="lua-table-th-lable" style="width: 8%">端口号</div>
              <div class="lua-table-th-lable" style="width: 8%">设备号</div>
              <div class="lua-table-th-lable" style="width: 8%">轮询周期</div>
              <div class="lua-table-th-lable" style="width: 10%">操作</div>
            </div>
            <div class="lua-table-td">
              <template v-if="list.length > 0">
                <div class="td-item" v-for="(indx, key) in list" :key="key">
                  <div class="lua-table-td-lable u-flex" style="width: 4%">
                    <div style="width: 100%" class="line-2">{{ key + 1 }}</div>
                  </div>
                  <div class="lua-table-td-lable" style="width: 15%">
                    <div style="width: 100%" class="line-2">
                      {{ indx.oilSiteName || "-" }}
                    </div>
                  </div>
                  <div class="lua-table-td-lable" style="width: 13%">
                    <div style="width: 100%" class="line-2">
                      {{ indx.oilSiteIotName || "-" }}
                    </div>
                  </div>
                  <div class="lua-table-td-lable" style="width: 8%">
                    <div style="width: 100%" class="line-2">
                      {{ indx.zhuangzhiName || "-" }}
                    </div>
                  </div>
                  <div class="lua-table-td-lable" style="width: 10%">
                    <div style="width: 100%" class="line-2">
                      {{ indx.deviceName || "-" }}
                    </div>
                  </div>
                  <div class="lua-table-td-lable" style="width: 8%">
                    <div style="width: 100%" class="line-2">
                      {{ indx.customerName || "-" }}
                    </div>
                  </div>
                  <div class="lua-table-td-lable" style="width: 9%">
                    <div style="width: 100%" class="line-2">
                      {{ indx.IP || indx.portName || "-" }}
                    </div>
                  </div>
                  <div class="lua-table-td-lable" style="width: 8%">
                    <div style="width: 100%" class="line-2">
                      {{ indx.Port || indx.parameter1 || "-" }}
                    </div>
                  </div>
                  <div class="lua-table-td-lable" style="width: 8%">
                    <div style="width: 100%" class="line-2">
                      {{ indx.SlaveId || indx.parameter2 || "-" }}
                    </div>
                  </div>
                  <div class="lua-table-td-lable" style="width: 8%">
                    <div style="width: 100%" class="line-2">
                      {{ indx.interval || "-" }}
                    </div>
                  </div>
                  <div class="lua-table-td-lable" style="width: 10%">
                    <div style="width: 100%" class="line-2 blue-btn u-flex">
                      <div
                        class="pot"
                        style="margin-right: 7px"
                        @click="deploy(indx)"
                      >
                        配置物联
                      </div>
                      <!-- <div
                        class="pot"
                        style="margin-right: 7px"
                        @click="del(indx)"
                      >
                        删除
                      </div> -->
                    </div>
                  </div>
                </div>
              </template>
              <div v-else class="u-flex u-row-center u-col-center mh">
                暂无内容
              </div>
            </div>
          </div>
        </template>
        <div class="drawer-footer" slot="footer"></div>
      </template>
      <template v-else>
        <div class="spin-height">
          <Spin>
            <Icon
              type="ios-loading"
              size="18"
              class="demo-spin-icon-load"
            ></Icon>
            <div>{{ loadingText }}</div>
            <!-- {{loadingText}} -->
          </Spin>
        </div>
        <div class="drawer-footer" slot="footer"></div>
      </template>
      <div class="rh-model" v-if="timbo" @click="modelmehods"></div>
    </Modal>
    <Modal
      class="common-drawer newModal"
      v-model="typeshowInDrawer"
      title="通信方式"
      width="500px"
      :mask-closable="false"
      @on-cancel="typecloseDrawer"
      class-name="vertical-center-modal"
    >
      <Form
        ref="formValidate"
        :rules="ruleValidate"
        :model="formData"
        label-position="top"
      >
        <FormItem required label="通信方式" prop="driverName">
          <!-- <Select @on-change="selcetmt" v-model="formData.driverId"> -->
          <Select v-model="formData.driverName">
            <Option
              v-for="item in dataTypeOption"
              :value="item.name"
              :key="item.name"
              >{{ item.name }}</Option
            >
          </Select>
        </FormItem>
      </Form>
      <div class="drawer-footer" slot="footer">
        <Button
          type="primary"
          @click="submitForm('formValidate')"
          :loading="btnLoading"
          >提交</Button
        >
        <Button style="margin-left: 8px" @click="typecloseDrawer">取消</Button>
        <div class="rh-model" v-if="timbo" @click="modelmehods"></div>
      </div>
    </Modal>
    <GateTypePoint
      @change="gettypechange"
      :clist="list"
      :formDate="typeformDate"
      v-model="pointShow"
      :CgetList="getList"
      :modelmehods="modelmehods"
      :timbo="timbo"
    />
    <GatePonit
      :getList="getList"
      :poinitFormDate="poinitFormDate"
      :poinitType="poinitType"
      v-model="gatePointShow"
      @change="getemethods"
      :modelmehods="modelmehods"
      :timbo="timbo"
    />

    <productEdit
      @change="proMtChange"
      :list="producObj.productlist"
      v-model="editshow"
      :id="curItemDetail.id"
      :modelmehods="modelmehods"
      :timbo="timbo"
      :reductionList="reductionList"
      :zhuangzhiId="glzhuangzhiId"
      :templateList="curItemDetail.oilSiteGatewayOriginalProductIdTemplateList"
    />
  </div>
</template>

<script>
import {
  bindDriver,
  olistiePage,
  unbindoilSite,
  getproductexcel,
  gatedetalog,
  distributionAdd,
  oilSitesuper,
  justifydriver,
  distributionAddAPI,
  distributionfinish,
  failurenext,
} from "@/api/knowledge/gateway";
import GateTypePoint from "./gateTypePoint-drawer.vue";
import GatePonit from "./gate-point.vue";
import chronicleDrawer from "./chronicle-drawer.vue";
import productEdit from "./productEdit.vue";

// 协议
const protocols = [
  'TCP',
  'RTU',
  'ETHERNET',
];

export default {
  components: {
    GateTypePoint,
    GatePonit,
    chronicleDrawer,
    productEdit,
  },
  name: "gateTypeDawer",
  props: {
    showtypeDrawer: Boolean,
    closeDrawer: Function,
    dataCenter: Object,
    getLists: Function,
    curItemDetail: Object,
    dataTypeOption: Array,
    timernum: {}, //多少秒自动关闭
  },

  data() {
    const validateid = (rule, value, callback) => {
      let driverId = this.driverId;
      if (driverId === "") {
        callback(new Error("请输入通信方式"));
      } else {
        callback();
      }
    };
    return {
      backupsdriver: "",
      detimer: null,
      editshow: false,
      loadingText: "",
      foolaoding: false,
      chrodata: [],
      chronidShow: false,
      gatePointShow: false,
      pointShow: false,
      typeshowInDrawer: false,
      showInDrawer: false,
      formData: {
        driverId: "",
        driverName: "",
      },
      btnLoading: false,
      formValidate: {},
      ruleValidate: {
        driverId: [{ validator: validateid, trigger: "blur" }],
      },
      formImte: null,
      typeformDate: {},
      isloading: true,
      list: [],
      poinitType: "",
      poinitFormDate: {},
      gettyperow: null,
      producObj: {
        id: "",
        productlist: [],
      },
      runisfinis: false, // 润滑点 false是没有关联过 true是关连过
      dbsfinis: false, //是否重置通信方式
      modstatus: 0, //0是直接点 1是点关联润滑点
      wantclick: false, //是否点击过
      finishCode: null,
      driverId: null,
      tttimer: null,
      timbo: false, // false是可以编辑的  true是编辑不了的
      reductionList: [],
      glzhuangzhiId:""
    };
  },
  computed: {
    apointShow() {
      let list = this.list;
      let finishCode = this.finishCode;
      //2是下发过的
      if (list.length == 0 || finishCode == 1) {
        return true;
      }
      return false;
    },
  },
  beforeDestroy() {
    clearInterval(this.detimer);
    this.detimer = null;
  },
  mounted() {},
  methods: {
    modelmehods() {
      this.$Modal.info({
        title: "提示",
        content: "页面编辑超时，请重新打开",
        onOk: () => {
          this.rest();
        },
      });
    },
    setClickStatus(bo) {
      if (!(this.wantclick == bo)) {
        this.wantclick = bo;
      }
    },
    rest() {
      console.log("我触发了");
      this.formData = {
        driverId: "",
        driverName: "",
      };
      this.list = [];
      this.producObj = {
        id: "",
        productlist: [],
      };
      this.reductionList=[]
      clearInterval(this.detimer);
      this.typeshowInDrawer = false;
      this.detimer = null;
      this.closeDrawer(0);
      this.pointShow = false;
      this.gatePointShow = false;
    },
    cccloseDrawer(index = 1) {
      if (this.isloading) {
        this.$Modal.confirm({
          title: "提示",
          content: "<p>正在下发点表，关闭对话框，下发操作仍会继续</p>",
          onOk: () => {
            this.rest();
          },
          onCancel: () => {},
        });
        return;
      }

      if (!this.wantclick) {
        this.rest();
      } else {
        this.$Modal.confirm({
          title: "提示",
          content:
            "<p>你尚未完成配置操作，关闭对话框后将不保存当前配置，是否继续？</p>",
          onOk: () => {
            this.rest();
          },
          onCancel: () => {},
        });
      }
    },
    proMtChange({ list }) {
      if (list) {
        this.finishCode = 2;
        this.producObj.productlist = list;
        this.setClickStatus(true);
      }
    },
    getbo(item1, item2) {
      let poinitType = this.poinitType;
      let obj1 = {};
      let obj2 = {};

      if (poinitType == "TCP") {
        obj1 = {
          IP: item1.IP,
          Port: item1.Port,
          SlaveId: item1.SlaveId,
          interval: item1.interval,
          PollsDelay: item1.PollsDelay,
        };
        obj2 = {
          IP: item2.IP,
          Port: item2.Port,
          SlaveId: item2.SlaveId,
          interval: item2.interval,
          PollsDelay: item2.PollsDelay,
        };
      } else if (poinitType === 'ETHERNET') {
        obj1 = {
          portName: item1.portName,
          parameter1: item1.parameter1,
          parameter2: item1.parameter2,
          interval: item1.interval,
          PollsDelay: item1.PollsDelay,
        };
        obj2 = {
          portName: item2.portName,
          parameter1: item2.parameter1,
          parameter2: item2.parameter2,
          interval: item2.interval,
          PollsDelay: item2.PollsDelay,
        };
      } else {
        obj1 = {
          portName: item1.portName,
          parameter1: item1.parameter1,
          parameter5: item1.parameter5,
          parameter2: item1.parameter2,
          parameter4: item1.parameter4,
          parameter3: item1.parameter3,
          interval: item1.interval,
          PollsDelay: item1.PollsDelay,
        };
        obj2 = {
          portName: item2.portName,
          parameter1: item2.parameter1,
          parameter5: item2.parameter5,
          parameter2: item2.parameter2,
          parameter4: item2.parameter4,
          parameter3: item2.parameter3,
          interval: item2.interval,
          PollsDelay: item2.PollsDelay,
        };
      }

      return this.$c.areObjectsEqual(obj1, obj2);
    },
    getemethods(row) {
      const { form } = this.$c.deepClone(row);

      let list = this.list;
      let index = list.findIndex((e) => e.oilSiteId == form.oilSiteId);
      let item = list[index];

      let bo = this.getbo(
        this.$c.deepClone(item.deviceInfo ? item.deviceInfo : item),
        this.$c.deepClone(form.deviceInfo)
      );

      item.deviceInfo = form.deviceInfo;
      item = { ...item, ...form.deviceInfo };
      this.$set(this.list, index, item);

      if (!bo) {
        this.finishCode = 2;
        this.setClickStatus(true);
      }
    },
    equation(arr1, arr2) {
      //是否相等
      let carr1 = arr1.map((item) => item.oilSiteId);
      let carr2 = arr2.map((item) => item.oilSiteId);
      return this.$c.areObjectsEqual(carr1, carr2);
    },
    gettypechange(row) {
      console.log("row",row)
   
      // const { songfaarr } = row;
      const songfaarr = this.$c.deepClone(row.songfaarr);

      let bo = this.equation(songfaarr, this.list);

      if (!bo) {
        this.finishCode = 2;
        this.setClickStatus(true);
      }

      if (songfaarr.length > 0) {
        let item = songfaarr[0];
        let row1 = this.list.length > 0 ? this.list[0] : { oilSiteId: "" };
        if (item.oilSiteId != row1.oilSiteId) {
          this.producObj = {
            oilSiteId: item.oilSiteId,
            productlist: item.productConfigInfo,
          };
          this.reductionList= item.productConfigInfo
        }
        this.glzhuangzhiId=songfaarr[0].zhuangzhiId
        console.log("this.glzhuangzhiId",this.glzhuangzhiId)
      }

      let list = songfaarr.map((item) => {
        let item1 = this.list.find(
          (item1) => item1.oilSiteId == item.oilSiteId
        );

        if (item1) {
          return item1;
        } else {
          return item;
        }
      });
      this.list = list;
      console.log("this.list", this.list);
    },
    navtoproedit(row = this.curItemDetail) {
      this.editshow = true;
     
    },
    async gatedistri() {
      if (this.list.length == 0) {
        this.$Message.info("请关联润滑点！");
        return;
      }
      console.log('list', this.list);
      let item = this.list.find((e) => !e.deviceInfo);
      if (item) {
        this.$Message.info("请完成配置物联");
        return false;
      }

      let zhuangzhiId = false;
      this.$Modal.confirm({
        render: (h) => {
          return [
            h(
              "div",
              {
                class: "dev-title",
              },
              ""
            ),
            [
              h(
                "div",
                {
                  class: "u-flex",
                  style: {
                    position: "relative",
                    top: "7px",
                  },
                },
                [
                  h(
                    "div",
                    {
                      style: {},
                    },
                    [
                      h("Checkbox", {
                        style: {
                          with: "90%",
                        },
                        props: {
                          value: zhuangzhiId,
                        },
                        on: {
                          "on-change": (event) => {
                            zhuangzhiId = event;
                          },
                        },
                      }),
                    ]
                  ),
                  h(
                    "div",
                    {
                      style: {
                        "margin-right": "10px",
                      },
                    },
                    "同时下发质量位"
                  ),
                ]
              ),
            ],
          ];
        },
        onCancel: async () => {},
        onOk: async () => {
          this.disoperation(zhuangzhiId);
        },
      });

 
    },
    async disoperation(bo) {
      this.loadingText = "正在下发...";
      this.isloading = true;
      try {
        const oilSiteGatewayBindUpOilQueryList = this.list.map((item) => {
          return {
            deviceInfo: JSON.stringify(item.deviceInfo),
            oilSiteId: item.oilSiteId,
          };
        });

        const { id: gatewayId } = this.curItemDetail;
        let oilList = this.list.map((e) => e.oilSiteId);
        let quality = bo ? 1 : 0;
        let productlist = this.producObj.productlist.map((e) => {
          e.id = null;
          return e;
        });
        // let justdata = await justifydriver({ gatewayId, oilList, quality });
        let formData = {
          // cleanDriver: justdata.data,
          // gatewayDriverId,
          gatewayId,
          oilSiteGatewayBindUpOilQueryList: oilSiteGatewayBindUpOilQueryList,
          gatewayProductPointTableList: productlist,
          // oilSiteGatewayProductIdTemplateList: productlist,
        };

        let data = await oilSitesuper({ ...formData });

        if (!data.data) {
          this.$Message.error(data.msg);
          throw data.msg;
        }

        // let data1 = await olistiePage(gatewayId); //详情接口

        // let data1s = data1.data;

        // let devicePointIdList =
        //   data1.data.oilSiteGatewayDetailOilSiteVOList.map(
        //     (e) => e.oilSiteGatewayDetailDeviceVO.deviceId
        //   );

        let xiafaobj = {
          // cleanDriver: justdata.data,
          // deplyType: "deploy",
          // devicePointIdList,
          // driverId: data1s.oilSiteGatewayDetailDriverVO.driverId,
          // driverName: data1s.oilSiteGatewayDetailDriverVO.driverName,
          // edgeInstanceId: data1s.edgeInstanceId,
          // gatewayDriverId: data1s.oilSiteGatewayDetailDriverVO.gatewayDriverId,
          gatewayId,
          // gatewayName: data1s.nickName,
          quality,
        };


        const xiafadata = await distributionAddAPI(xiafaobj);

        this.isloading = false;

        if (xiafadata.code == "00000") {
          // this.distribute(xiafaobj.gatewayId);
          this.$Message.success(xiafadata.data);
          this.setClickStatus(false);
          this.$nextTick(() => {
            this.cccloseDrawer(0);
          });
        } else {
          this.$Message.info(xiafadata.msg);
        }
      } catch (error) {
        this.isloading = false;
      }
    },
    async waterCommCate(id) {
      let { data } = await distributionfinish(id);

      if (data.finishCode == 0) {
        this.loadingText = "正在下发...";
        this.isloading = true;
        // this.distribute(id);
      } else if (data.finishCode == 3) {
        this.isstout(id);
      } else {
        this.isloading = false;
      }
    },
    async distribute(id) {
      if (this.detimer) {
        clearInterval(this.detimer);
        this.detimer = null;
      }
      this.$nextTick(() => {
        this.detimer = setinterval(async () => {
          let data = await distributionfinish(id);

          if (data.code == "00000") {
            let finishCode = data.data.finishCode;
            if (finishCode == 1) {
              this.$Message.success("下发成功");
              this.isloading = false;
              clearInterval(this.detimer);
              this.detimer = null;

              this.setClickStatus(false);
              this.$nextTick(() => {
                this.cccloseDrawer(0);
              });
            } else if (finishCode == 3) {
              this.isstout(id);
            }
          }
          //  this.isloading = false;
        }, 1000 * 20);
      });
    },
    isstout(id) {
      //超时操作
      this.$Modal.warning({
        title: "提示",
        content: "请确认网关正确接入网络或稍后重试",
        onOk: () => {
          this.isloading = false;
          clearInterval(this.detimer);
          this.detimer = null;
          failurenext(id);
        },
      });
    },
    async gatedistri1(row = this.curItemDetail) {
      let zhuangzhiId = true;
      this.$Modal.confirm({
        render: (h) => {
          return [
            h(
              "div",
              {
                class: "dev-title",
              },
              ""
            ),
            [
              h(
                "div",
                {
                  class: "u-flex",
                },
                [
                  h(
                    "div",
                    {
                      style: {},
                    },
                    [
                      h("Checkbox", {
                        style: {
                          with: "90%",
                        },
                        props: {
                          value: zhuangzhiId,
                        },
                        on: {
                          "on-change": (event) => {
                            zhuangzhiId = event;
                          },
                        },
                      }),
                    ]
                  ),
                  h("div", {
                    style: {
                      "margin-right": "10px",
                    },
                  }),
                ]
              ),
            ],
          ];
        },
        onCancel: async () => {},
        onOk: async () => {
          this.setdistributionAdd(row, zhuangzhiId);
        },
      });
    },

    async setdistributionAdd(row, zhuangzhiId) {
      this.loadingText = "正在下发...";
      this.isloading = true;
      try {
        let { data } = await olistiePage(row.id); //全部驱动
        let datas = data;

        const { driverId, driverName, gatewayDriverId } =
          datas.oilSiteGatewayDetailDriverVO;
        const vodatas = datas.oilSiteGatewayDetailOilSiteVOList[0];

        let obj = {
          deplyType: "deploy",
          devicePointIdList: [vodatas.oilSiteGatewayDetailDeviceVO.deviceId],
          driverId,
          driverName,
          edgeInstanceId: datas.edgeInstanceId,
          gatewayDriverId,
          gatewayId: datas.id,
          gatewayName: datas.nickName,
          quality: zhuangzhiId,
        };

        // let productdata = await configThingModel(obj);
        let productdata = await distributionAdd(obj);

        this.isloading = false;
        if (productdata.code == "00000") {
          this.$Message.success("操作成功");
        } else {
          this.$Message.info(productdata.msg);
        }
        this.$store.state.spinShow = false;
      } catch (error) {
        this.isloading = false;
      }
    },

    async electricity(row) {
      this.isloading = true;
      let data = await getproductexcel(
        row.oilSiteGatewayDetailDeviceVO.deviceId
      );
      this.isloading = false;

      if (data.code == "00000") {
        this.$Message.success("操作成功");
      } else {
        this.$Message.info(data.msg);
      }
    },
    deploy(row) {
      if (this.formData.driverName.toLowerCase().includes("tcp")) {
        this.poinitType = "TCP";
      } else if (this.formData.driverName.toLowerCase().includes('ethernet')) {
        this.poinitType = 'ETHERNET';
      } else {
        this.poinitType = "RTU";
      }

      this.poinitFormDate = {
        gatewayId: this.typeformDate.gatewayId,
        gatewayDriverId: this.typeformDate.gatewayDriverId,
        ...row,
        ...row.deviceInfo,
        deviceInfo: row.deviceInfo,
      };

      this.gatePointShow = true;
    },
    async association() {
      let { data } = await olistiePage(this.curItemDetail.id);

      this.typeformDate.gatewayId = this.curItemDetail.id;
      this.typeformDate.customerId = this.curItemDetail.tenantId;
      if (data.oilSiteGatewayDetailDriverVO) {
        this.typeformDate.type =
          data.oilSiteGatewayDetailDriverVO.interfaceType;
      }

      if (this.formData.driverName) {
        this.pointShow = true;
      } else {
        this.$Message.info("请先配置通信方式!");
      }
      // if (this.formData.driverName) {
      //   this.backupsdriver = this.$c.deepClone(this.formData.driverName);

      //   this.updatereport(1);
      //   // this.pointShow = true;
      // } else {
      //   this.updatereport(1);
      // }
      //else {
      //   this.$Message.info("请先配置通信方式!");
      // }
    },
    selcetmt(item) {
      if (!item) return;
      this.formImte = this.dataTypeOption.find((e) => e.driverId == item);
      this.formData.driverName = this.$c.deepClone(this.formImte.name);
    },
    typecloseDrawer() {
      this.typeshowInDrawer = false;
      this.$nextTick(() => {
        this.driverId = null;
      });
    },
    updatereport(index = 0) {
      this.modstatus = index;
      this.driverId = this.formData.driverId;
      //  this.msg="更换驱动将清空现有网关配置"

      if (this.formData.driverId) {
        this.formImte = this.dataTypeOption.find(
          (e) => e.driverId == this.formData.driverId
        );
      }
      // this.modstatus = 0;

      this.typeshowInDrawer = true;
    },

    submitForm(name1) {
      this.btnLoading = true;

      this.$refs["formValidate"].validate((valid) => {
        if (valid) {
          // this.formData.driverId = this.driverId;
          // this.selcetmt(this.formData.driverId);
          // if (
          //   this.formData.driverName &&
          //   this.backupsdriver == this.formData.driverName
          // ) {
          //   this.typecloseDrawer();
          //   this.btnLoading = false;
          //   if (this.modstatus == 1) {
          //     this.$nextTick(() => {
          //       this.pointShow = true;
          //     });
          //     return;
          //   }
          // }
          // this.backupsdriver = this.formData.driverName;
          // this.typeformDate.type = this.formImte.driverType;

          // if (this.modstatus == 1) {
          //   if(!this.backupsdriver){
          //     this.backupsdriver = this.formData.driverName

          //   }

          //   this.typecloseDrawer();
          //   this.btnLoading = false;
          //   this.$nextTick(() => {
          //     this.pointShow = true;
          //   });
          //   return;
          // }
          try {
            this.foolaoding = true;
            // const { driverId, name, versionInfo } = this.formImte;
            const { edgeInstanceId, id } = this.curItemDetail;
            // let devitem = this.dataTypeOption.find(
            //   (e) => e.driverId == driverId
            // );

            let obj = {
              gatewayId: id,
              driverType: this.formData.driverName,
            };

            bindDriver(obj)
              .then((res) => {
                this.btnLoading = false;
                if (res.code === "00000") {
                  this.dbsfinis = true;
                  if (this.modstatus == 1) {
                    this.$nextTick(() => {
                      this.pointShow = true;
                    });
                  } else {
                    this.$Message.success("提交成功!");
                  }
                  this.typecloseDrawer();
                  this.getList();
                } else {
                  this.$Message.info(res.msg);
                }
              })
              .catch((error) => {
                this.btnLoading = false;
              });
          } catch (error) {}

          this.foolaoding = false;
        } else {
        }
      });
    },
    async getList(row = this.curItemDetail, bo = false, text = "Refresh") {
      this.isloading = true;

      let olistiePagedata = await olistiePage(row.id); //全部驱动
      console.log('olistiePagedata',olistiePagedata)
      let data1 = olistiePagedata.data;
      this.glzhuangzhiId=data1.zhuangzhiId
 
     
      this.reductionList = data1.oilSiteGatewayOriginalProductIdTemplateList;
      //   const { data1 } = newValue;
      // 2 没有下发过
      this.finishCode = data1.finishCode;
      if (this.finishCode == 2) {
        this.runisfinis = false;
      } else {
        this.runisfinis = true;
      }

      if (data1.driverType) {
        this.formData.driverName = data1.driverType;
      }

      if (data1.oilSiteGatewayDetailDriverVO) {
        const { driverId, driverName, gatewayDriverId } =
          data1.oilSiteGatewayDetailDriverVO;
        this.formData.driverId = driverId;
        this.formData.driverName = driverName;
        this.typeformDate = {
          gatewayDriverId,
          gatewayId: data1.id,
        };
      }
      if (data1.oilSiteGatewayDetailOilSiteVOList) {
        this.list = data1.oilSiteGatewayDetailOilSiteVOList.map((item) => {
          if (
            item.oilSiteGatewayDetailDeviceVO &&
            item.oilSiteGatewayDetailDeviceVO.deviceInfo
          ) {
            let deviceInfo = item.oilSiteGatewayDetailDeviceVO.deviceInfo;
            item.IP = deviceInfo.IP;
            item.Port = deviceInfo.Port;
            item.SlaveId = deviceInfo.SlaveId;
            item.interval = deviceInfo.interval;
            item.DataBit = deviceInfo.DataBit;
            item.StopBit = deviceInfo.StopBit;
            item.Parity = deviceInfo.Parity;
            item.BaudRate = deviceInfo.BaudRate;
            item.SerialDevice = deviceInfo.SerialDevice;
            item.deviceInfo = deviceInfo;

            item.parameter1 = deviceInfo.parameter1;
            item.parameter2 = deviceInfo.parameter2;
            item.parameter3 = deviceInfo.parameter3;
            item.parameter4 = deviceInfo.parameter4;
            item.parameter5 = deviceInfo.parameter5;
            item.portName = deviceInfo.portName;
            item.PollsDelay = deviceInfo.PollsDelay;
          }
          item.zhuangzhiName = data1.zhuangzhiName;
          return item;
        });

        if (bo == true) {
          let item = this.list.find((e) => e.oilSiteId == this.gettyperow.id);

          if (item) {
            this.deploy(item);
          }
          //19f91af5e93243648776f61f86bbfa17
        }
      }
      this.$nextTick(() => {
        if (!this.formData.driverName) {
          this.typeshowInDrawer = true;
        } else {
          if (this.formData.driverName.toLowerCase().includes("tcp")) {
            this.poinitType = "TCP";
          } else if (this.formData.driverName.toLowerCase().includes('ethernet')) {
            this.poinitType = 'ETHERNET';
          } else {
            this.poinitType = "RTU";
          }
        }

        this.producObj.productlist = data1.gatewayProductPointTableList && data1.gatewayProductPointTableList.length > 0 ? data1.gatewayProductPointTableList : data1.oilSiteGatewayProductIdTemplateList;
        // if (text == "init") {
        //   // this.waterCommCate(row.id); //是否在通行
        // } else {
        //   this.isloading = false;
        // }
        this.isloading = false;
      });
    },
    reset(key) {
      Object.keys(this[key]).forEach((item) => {
        this[key][item] = "";
      });
    },
    del(row) {
      this.$Modal.confirm({
        title: "您确定要删除该关联润滑点吗？",
        content: ` <div>润滑点名称：${row.oilSiteName}</div>`,

        onOk: async () => {
          let data = await unbindoilSite(row.gatewayOilSiteId);
          if (data.code == "00000") {
            this.$Message.success("提交成功!");
            this.getList();
          } else {
            this.$Message.info(data.msg);
          }
        },
        onCancel: () => {},
      });
    },
    setregulartimer() {
      console.log("timernum", this.timernum);
      clearTimeout(this.tttimer);
      this.tttimer = null;
      this.tttimer = setTimeout(() => {
        this.timbo = true;
        clearTimeout(this.tttimer);
      }, this.timernum);
      // this.timernum
    },
  },
  watch: {
    curItemDetail: {
      handler: async function (newValue, oldValue) {
        if (!this.showtypeDrawer) return;
        if (newValue !== oldValue) this.$refs.formValidate.resetFields();
        if (newValue.id) {
          this.getList(newValue, false, "init");
        } else this.formData = {};
      },
      deep: true,
    },
    showtypeDrawer: {
      handler: function (newValue, oldValue) {
        this.setClickStatus(false);
        this.dbsfinis = false;
        this.loadingText = "";
        this.isloading = true;
        this.showInDrawer = newValue;
        this.timbo = false;
        if (this.showInDrawer) {
          this.setregulartimer();
        }
      },
      deep: true,
    },
  },
};
</script>
<style>
.dev-title {
  font-size: 16px;
  color: #17233d;
  font-weight: 500;
  position: relative;
  top: -11px;
}

.demo-spin-icon-load {
  animation: ani-demo-spin 1s linear infinite;
}
@keyframes ani-demo-spin {
  from {
    transform: rotate(0deg);
  }
  50% {
    transform: rotate(180deg);
  }
  to {
    transform: rotate(360deg);
  }
}
.demo-spin-col {
  height: 100px;
  position: relative;
  border: 1px solid #eee;
}
</style>

<style lang='less' scoped>
.rhlistDrawer {
}
.gat-labe {
  font-size: 14px;

  font-weight: 400;
  color: #555555;
  span {
    font-weight: 400;
    color: #0c479d;
    position: relative;
    left: 5px;
  }
}

.lua-table {
  overflow-y: scroll;

  .lua-table-th {
    padding: 8px 5px;
    width: 100%;
    height: 34px;
    background: #f5f5f5;
    display: flex;
    justify-content: space-between;
    font-size: 12px;
    font-weight: 400;
    color: #000000;
    z-index: 1000;
    position: sticky;
    top: 0;

    .lua-table-th-lable {
      margin-right: 5px;
      text-align: left;
    }
  }

  .lua-table-td {
    height: 268px;
    //   overflow: auto;

    .td-item {
      display: flex;
      justify-content: space-between;
      border-bottom: 1px solid #ebebeb;
      box-sizing: border-box;
      padding: 0 5px;

      .lua-table-td-lable {
        margin-right: 5px;
        text-align: left;
        font-size: 12px;
        height: 53px;
        font-weight: 400;
        color: #333333;
        display: flex;
        align-items: center;
        justify-content: center;
        display: flex;
        align-items: center;
      }
    }
  }
}
.spin-height {
  height: 395px;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}
.blue-btn {
  font-size: 12px;
  font-family: PingFang SC-Regular, PingFang SC;
  font-weight: 400;
  color: #0c479d;
}
</style>